'use client';

import type { Route } from 'next';
import React, { createContext, useContext } from 'react';
import type { PropsWithChildren } from 'react';

import type { JobDetailVM } from '@/modules/job/view-models';

import { CompanyGallery } from './CompanyGallery';
import { CompanyInformation } from './CompanyInformation';
import { JobDetailHeader } from './JobDetailHeader';
import { JobDetailHowToApply } from './JobDetailHowToApply';
import { JobDetailJobDetail } from './JobDetailJobDetail';
import { SpecialInformation } from './SpecialInformation';

export type JobDetailProps = {
	entryUrl: Route<string>
	job:      JobDetailVM

	handleAddInterestedJob?:    () => void
	handleRemoveInterestedJob?: () => void
};

type JobDetailContextType = JobDetailProps;

const JobDetailContext = createContext<JobDetailContextType | undefined>(undefined);

export const useJobDetailContext = () => {
	const context = useContext(JobDetailContext);

	if (!context) throw new Error('useJobDetailContext must be used within a JobDetailProvider');

	return context;
};

export const JobDetailRoot = (props: PropsWithChildren<JobDetailProps>) => {
	return (
		<JobDetailContext.Provider value={props}>
			{props.children}
		</JobDetailContext.Provider>
	);
};

export const JobDetail = {
	CompanyGallery:     CompanyGallery,
	CompanyInformation: CompanyInformation,
	Header:             JobDetailHeader,
	HowToApply:         JobDetailHowToApply,
	JobDetail:          JobDetailJobDetail,
	Root:               JobDetailRoot,
	SpecialInfo:        SpecialInformation,
};
